import { ModalProvider } from "styled-react-modal";
import { FadingBackground, StyledInformationModal } from "./GenericInformationModalStyles";
import React, { useState, useContext } from "react";
import { InformationContext } from "src/consumer/context/InformationContext";
import AppExclusiveScreen from "./AppExclusiveScreen";


export const GenericInformationModal = () => {

    const [opacity, setOpacity] = useState(0);
    const { informationModalData, setInformationModalData } = useContext(InformationContext);
    const { showModal, data } = informationModalData

    function toggleModal(e) {
        setOpacity(0);
        setInformationModalData({ showModal: false, data: {} });
    }
    function afterOpen() {
        setTimeout(() => {
            setOpacity(1);
        }, 100);
    }
    function beforeClose() {
        return new Promise((resolve) => {
            setOpacity(0);
            setTimeout(resolve, 300);
        });
    }

    return (
        <ModalProvider backgroundComponent={FadingBackground}>
            <StyledInformationModal
                isOpen={showModal}
                afterOpen={afterOpen}
                beforeClose={beforeClose}
                onEscapeKeydown={toggleModal}
                opacity={opacity}
                backgroundProps={{ opacity }}
            >

                {data?.toShow === "app_exclusive" &&
                    <AppExclusiveScreen closeModal={toggleModal} />
                }

            </StyledInformationModal>
        </ModalProvider >
    )

}